//Save to Desktop Items > app_projects_portfolio> Backup > internet-idol-faceoff folder.
//To create an issue with command line, you need to get out of bash and create a c:\cmd.

import React, { useEffect } from 'react'

//Pages.
import Home from './pages/public/homePage/Home';
import AllVideosPage from './pages/public/allVideosPage/AllVideosPage';
import ChallengesPage from './pages/public/challengesPage/ChallengesPage';
import ChallengePage from './pages/private/challenge-page/ChallengePage';
import ChallengeDetailsPage from './pages/public/challengeDetailsPage/ChallengeDetailsPage';
import CompletedChallengesPage from './pages/public/completedChallengePage/CompletedChallengesPage';
import Instructions from './pages/public/instructionsPage/Instructions';
import MemberHomePage from './pages/private/logged-in-member-pages/member-home-page/MemberHomePage';

//Components.
import ActiveChallengesComponent from './components/challenges/active-challenges/ActiveChallengesComponent';
import ChallengeAnnouncementsPage from './pages/public/challengeAnnouncementsPage.js/ChallengeAnnouncementsPage';
import MainNavbar from './components/navigation-bars/main-navbar/MainNavbar';
import MembersStatsComponent from './components/members-home-components/members-stats-components/MembersStatsComponent';
import WelcomeComponent from './components/members-home-components/welcome-component/WelcomeComponent';

//Dependencies.
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//Functions.
   import {getDataFromEachDocument, updateChallengeAnnouncementInFS } from './functions/firebase/firestore';
  //Callback.
  import { loggedInUser } from './slices/allUsersSlice';
  import { calculateDaysRemaining } from './functions/momentJS';
  import { FStransferChallengeFromUpcomingToActive } from './slices/challengesSlice';    
import { updateVideo, videosReducer } from './slices/allVideosSlice';

const Routing = () => {
   const currentUser = useSelector(loggedInUser);
   const allVideos = useSelector(videosReducer).allVideos;
   const dispatch = useDispatch();

   useEffect(() => {
      getDataFromEachDocument("upcomingChallengeProperties")
         .then(result => {
            /*
               the "result" argument is an array where each element contains: { allData, requestedFieldValue: in this case is the "upcomingChallengeProperties", _challengeID }.
            */
            return result.map(val => {
               const daysLeft = calculateDaysRemaining(val.requestedFieldValue.challengeAnnouncementEndDate);
               const updatedRequestedFieldValue = { ...val.requestedFieldValue, daysRemainingBeforeAnnouncementEnds: daysLeft };
               const updatedVal = { ...val.allData, upcomingChallengeProperties: { ...updatedRequestedFieldValue } };

               /*
                  const updatedVal = { activeChallengeProperties, challengeVideos, coverImageDetails, upcomingChallengeProperties: { the only new/updated value here is daysRemainingBeforeAnnouncementEnds } }.
               */

               return updatedVal;
            })
         })
         .then(result => {

            return result.map(val => {
               const { _challengeID, upcomingChallengeProperties: { daysRemainingBeforeAnnouncementEnds } } = val; //Destructuring _challengeID & daysRemiainingBeforeAnnouncementEnds (which is updated) because we need these two values as arguments in updateChallengeAnnouncementInFS (see below).

               const updateChallenge = updateChallengeAnnouncementInFS(_challengeID, { "upcomingChallengeProperties.daysRemainingBeforeAnnouncementEnds": daysRemainingBeforeAnnouncementEnds })
                  .then(success => console.log({ message: "updateChallengeAnnouncementInFS is successful!!!", success }))
                  .catch(error => console.error({ origin: "updateChallengeAnnouncementInFS", error, errorCode: error.code, errorMessage: error.message }));

               return { _challengeID, daysRemainingBeforeAnnouncementEnds, updatedObject: val, updateChallenge };
            })
         })
         .then(valueObject => {
            valueObject.forEach(val => {
               //val = { _challengeID, daysRemaingingBeforeAnnouncementEnds, updatedObject };
               
               if (val.daysRemainingBeforeAnnouncementEnds < 1) {
                  dispatch(FStransferChallengeFromUpcomingToActive({ oldType: "allUpcomingChallenges", newType: "allActiveChallenges", key: val._challengeID, value: val.updatedObject }));
               } //for ChallengeAnnouncementDetails.js.           
            });
         })
         .catch(error => console.error({ error, errorCode: error.code, errorMessage: error.message }));

      return () => {
         
      }
   }, []);

   return (
      <BrowserRouter>
         <MainNavbar />
         <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/challenges/*' element={<ChallengesPage />}>
               <Route path='actives/:filterBy' element={<ActiveChallengesComponent />} />
               <Route path='announcements/:filterBy' element={<ChallengeAnnouncementsPage />} />
               <Route path='completed' element={<CompletedChallengesPage />} />
               <Route path='details/:type/:_challengeID' element={<ChallengeDetailsPage />} />
            </Route>
            <Route path="/instructions" element={<Instructions />} />
            <Route path='/videos/all' element={<AllVideosPage />} />

            {/* START PRIVATE ROUTES */}
               {
                  currentUser._userID
                  &&
                  <>
                     <Route path='/member/_userID/:_userID/*' element={<MemberHomePage />}>
                        <Route path='home' element={<WelcomeComponent />} />
                        <Route path='stats' element={<MembersStatsComponent />} />
                        <Route path='videos/currentUser' element={<AllVideosPage />} />
                        <Route path='challenges/*' element={<ChallengesPage />}>
                           <Route path='actives/:filterBy' element={<ActiveChallengesComponent />} />
                           <Route path='announcements/:filterBy' element={<ChallengeAnnouncementsPage />} />
                           <Route path='details/:type/:_challengeID' element={<ChallengeDetailsPage />} />
                        </Route>
                        <Route path='challenges/create' element={<ChallengePage />} />
                     </Route>
                     <Route path='/member/_userID/:_userID/challenges/create' element={<ChallengePage />} />
                  </>
               }
               
            {/* END PRIVATE ROUTES */}

            <Route path="*" element={<Navigate to='/' replace />} />
         </Routes>
      </BrowserRouter>
   )
}

export default Routing